import useCart from "./useCart";
import useRewards from "./useRewards";

export default function useReward(){

    const rewardsQuery = useRewards();

    const rewards = rewardsQuery.isSuccess ? rewardsQuery.data : [];

    const { cart } = useCart();

    if( !cart.reward ) return null;

    return rewards.find(r => r.id === cart.reward) || null;
}